function convertToSeconds(time: string) {
  const parts = time.split(',')
  const [hours, minutes, seconds] = parts[0].split(':').map((part) => parseFloat(part))
  return hours * 3600 + minutes * 60 + parseFloat(`${seconds}`) + parseFloat(parts[1]) / 1000
}

export type Subtitle = {
  start: number
  end: number
  text: string
}

export default class SubtitleTrack {
  subtitles: Subtitle[] = []
  parseSRT(content: string) {
    this.subtitles = []
    const pattern =
      /(\d{2}):(\d{2}):(\d{2})\.(\d{3}) --> (\d{2}):(\d{2}):(\d{2})\.(\d{3})\r?\n([\s\S]*?)(?=\r?\n\r?\n|\r?\n*$)/g
    let match: RegExpExecArray | null
    while ((match = pattern.exec(content))) {
      const startHours = parseInt(match[1], 10)
      const startMinutes = parseInt(match[2], 10)
      const startSeconds = parseInt(match[3], 10)
      const startMilliseconds = parseInt(match[4], 10)
      const endHours = parseInt(match[5], 10)
      const endMinutes = parseInt(match[6], 10)
      const endSeconds = parseInt(match[7], 10)
      const endMilliseconds = parseInt(match[8], 10)

      const startTimeInSeconds = startHours * 3600 + startMinutes * 60 + startSeconds + startMilliseconds / 1000
      const endTimeInSeconds = endHours * 3600 + endMinutes * 60 + endSeconds + endMilliseconds / 1000

      this.subtitles.push({
        start: startTimeInSeconds,
        end: endTimeInSeconds,
        text: match[9].trim(),
      })
    }
  }

  getSubtitleAt(time: number): Subtitle {
    return this.subtitles.find((subtitle) => time >= subtitle.start && time <= subtitle.end)
  }
}
